<template>
    <div class="text-center col-12" v-if="transaction">
        <vue_html2pdf
                :show-layout="true"
                :float-layout="true"
                :enable-download="true"
                :preview-modal="false"
                :paginate-elements-by-height="3000"
                :filename="'Invoice '+transaction._store.name+' '+today()"
                :pdf-quality="2"
                :manual-pagination="true"
                pdf-format="a4"
                pdf-orientation="landscape"
                pdf-content-width="800px"
                :html-to-pdf-options="htmlToPdfOptions"
                @progress="onProgress($event)"
                @hasStartedGeneration="hasStartedGeneration()"
                @hasGenerated="hasGenerated($event)"
                ref="html2Pdf">
            <section slot="pdf-content">
                <InvoiceFirst :transaction="transaction"></InvoiceFirst>
            </section>
        </vue_html2pdf>
            <v-btn  style="z-index: 9999999999" @click="generateReport"  dark fixed bottom right fab>
                <v-icon>mdi-download</v-icon>
            </v-btn>
         <v-btn @click="goToPaymentGate(transaction_id)" style="z-index: 9999999999"  color="indigo" dark fixed bottom left fab>
                <v-icon>mdi-keyboard-return</v-icon>
            </v-btn>
      <v-btn @click="reloadPage()" style="z-index: 9999999999" color="powderBlue" dark fixed bottom  fab>
                <v-icon>mdi-reload</v-icon>
            </v-btn>
    </div>
    <div class="loader" v-else>
        <div class="loading">
            <img v-lazy="'/images/logo_mini_intram.jpg'" width="100px" alt="">
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import VueHtml2pdf from 'vue-html2pdf'
    export default {
        name: "invoiceTemplate",
        components: {
            vue_html2pdf:   VueHtml2pdf,
        },
        data(){
            return {
                transaction_id:null,
                htmlToPdfOptions: {
                    margin: 0,
                    image: {
                        type: 'png',
                        quality: 0.98
                    },
                    enableLinks: true,
                    html2canvas: {
                        scale: 1,
                        useCORS: true
                    },
                    jsPDF: {
                        unit: 'in',
                        format: 'a4',
                        orientation: 'landscape'
                    }
                }
            }
        },
        computed:{
            ...mapState('payments/',['transaction','error','message','means_of_paiements']),
            preferedCountries(){
                let array = [];
                this.means_of_paiements.forEach((mean)=>{
                    if (mean._type=== process.env.VUE_APP_MOBILE){
                        array.push(mean._country._code.toUpperCase())
                    }
                })
                return array;
            },
        },
        methods:{
            goToPaymentGate(id){
              this.$router.push('/payment/gate/'+id);
            },
           reloadPage(){
              location.reload();
            },
            today(){
                let today = new Date(),
                 dd = String(today.getDate()).padStart(2, '0'),
                 mm = String(today.getMonth() + 1).padStart(2, '0'), //January is 0!
                 yyyy = today.getFullYear();
               return  mm + '-' + dd + '-' + yyyy;

            },
            checkisDashboard(){
                this.$emit('checkisDashboard',false);
            },

            generateReport () {
                this.$refs.html2Pdf.generatePdf()
            },
        },
        created() {
            this.checkisDashboard();
        },
        mounted (){
            this.transaction_id=this.$route.params.transaction_id;
            if (this.$route.params.transaction_id){
                this.$store.dispatch('payments/getPaymentGateTransaction',this.$route.params.transaction_id).then((response)=>{console.log(response)})
            }
        },
    }

</script>


<style scoped>

    .loader{
        z-index: 999;
        text-align: center;
        min-width: 100vw;
        background: #f8f8f8;
        min-height: 100vh;
        position: absolute;
        top: 0;
    }
    .loading{
        position: absolute;
        left: 45%;
        top: 40%;
        z-index: 1;
        padding: 0;
        margin: 0;
        background: #f8f8f8;
        -webkit-animation: flickerAnimation 2s infinite;
        -moz-animation: flickerAnimation 2s infinite;
        -o-animation: flickerAnimation 2s infinite;
        animation: flickerAnimation 2s infinite;
    }
    .shop-info{
        text-align: center;padding: 0;
        background: rgba(12,21,32,0.5);
        line-height: 90px;
    }

    img-header-gate{
        padding: 20px;
    }
    .img-header-gate img{
        width: 100%;
    }
    .text-details{
        font-size: 12pt;
    }
    .detail_paiement{
        padding-top: 15px;
        background: #fff;
    }
    .close_details{
        font-size: 12pt;
        border-radius: 50px;
        background: rgba(3, 113, 0, 0.8);
        padding: 5px 12px;
        color: #fff!important;
        cursor: pointer;
        margin-right: 30px;
        margin-bottom: 0;
    }
    .itemsTilte{
        color: #fff;
        padding: 7px 12px;
        cursor: pointer;
        margin-bottom: 0;
    }

    @media (max-width: 991px) {

        .texteLogo{
            font-size: 20pt;
            display: inline;
        }

        .text-details{
            font-size: 8pt !important;
            margin-top: -10px;
        }

        .itemsTilte{
            padding: 5px 12px;
            font-size: 10pt;
        }

        .img-header-gate_mini img{
            width: 100px;
            height: 100px;
            border-radius: 50%;
            border: 10px solid #1e3551;
        }

    }

    .footer-gate-payment img{
        width: 50px;
    }
    .top-second-gate-header{
        color: #fff;
        padding: 0 10px;
    }
    .top-second-gate-header .htitle{
        font-size: 7pt;
    }


    .portail_text{
        font-size: 25pt;
        font-weight: 500;
        padding: 10px;
    }
    .shop_name{
        font-weight: 500;
        font-size: 10pt;
    }
    .paiement_price_box{
    }
    .paiement_price_box .htitle{
        font-size: 8pt;
        font-weight: 500;
    }
    .paiement_price_box .price{
        font-size: 20pt;
        font-weight: bold;
    }
    .payment-mean-img{
        height: 10%;
    }

    @keyframes flickerAnimation {
        0%   { opacity:1; }
        50%  { opacity:0.1; }
        100% { opacity:1; }
    }
    @-o-keyframes flickerAnimation{
        0%   { opacity:1; }
        50%  { opacity:0.1; }
        100% { opacity:1; }
    }
    @-moz-keyframes flickerAnimation{
        0%   { opacity:1; }
        50%  { opacity:0; }
        100% { opacity:1; }
    }
    @-webkit-keyframes flickerAnimation{
        0%   { opacity:1; }
        50%  { opacity:0; }
        100% { opacity:1; }
    }

</style>
